export default __webpack_public_path__ + "static/media/copy.55212601.svg";